import { getButtonVariants } from '../../../theme/utils/button.theme.utils';
export var buttonTheme = {
  baseStyle: _ref => {
    var {
      isLoading,
      isFullWidth
    } = _ref;
    return {
      container: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        borderRadius: 'l',
        transitionProperty: 'common',
        transitionDuration: 'normal',
        width: isFullWidth ? '100%' : 'auto',
        outline: 'transparent solid 2px',
        _loading: {
          pointerEvents: 'none'
        },
        _disabled: {
          cursor: 'not-allowed'
        }
      },
      label: {
        display: 'inherit',
        alignItems: 'inherit',
        justifyContent: 'inherit',
        visibility: isLoading ? 'hidden' : 'visible',
        whiteSpace: 'nowrap'
      },
      icon: {
        display: 'inline-flex',
        marginInlineEnd: 'xs'
      },
      loader: {
        display: 'inline-flex',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)'
      }
    };
  },
  sizes: {
    small: _ref2 => {
      var {
        icon
      } = _ref2;
      return {
        container: {
          textStyle: 'body4Semi',
          height: '32px',
          paddingInlineStart: icon ? 'xs' : 's',
          paddingInlineEnd: 's'
        },
        label: {
          minWidth: '64px',
          marginInlineStart: icon ? 'xxs' : 'none'
        }
      };
    },
    medium: _ref3 => {
      var {
        icon
      } = _ref3;
      return {
        container: {
          textStyle: 'body3Semi',
          height: '40px',
          paddingX: 's'
        },
        label: {
          minWidth: '72px',
          marginInlineEnd: icon ? 'xxs' : 'none'
        }
      };
    },
    large: _ref4 => {
      var {
        icon
      } = _ref4;
      return {
        container: {
          textStyle: 'body2Semi',
          height: '48px',
          paddingInlineStart: icon ? 's' : 'm',
          paddingInlineEnd: 'm'
        },
        label: {
          minWidth: '72px',
          marginInlineStart: icon ? 'xxs' : 'none'
        }
      };
    }
  },
  variants: getButtonVariants(),
  defaultProps: {
    variant: 'primary',
    size: 'medium'
  }
};
//# sourceMappingURL=Button.theme.js.map